<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UserMenu',
})
</script>
<template>
  <div class="user-wrapper">
    <div class="flex align-center">
      <notice-icon class="action" />
       <span class="action">
        <CheckOutlined class="text-primary" v-if="mqttConnect" />
        <CloseOutlined class="text-gray" v-else />
         <span class="padding-left-xs">mqtt服务器</span>
      </span>
      <a-dropdown>
        <span v-if="UserInfo" class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" v-if="UserInfo.pic" size="small" :src="baseURL+UserInfo.pic" />
          <a-avatar class="avatar" v-else size="small" src="@/assets/img/user.png" />
          <span class="nickname">{{ UserInfo.username }}</span>
        </span>
        <template #overlay>
          <a-menu class="user-dropdown-menu-wrapper">
            <a-menu-item key="0">
            <router-link :to="{ name: 'account' }">
              <UserOutlined />
              <span>个人中心</span>
            </router-link>
            </a-menu-item>
            <a-menu-item key="4" @click="showSystemSetting">

                <SettingOutlined />
                <span>{{ $t('tools.userMenu.systemConfig') }}</span>

            </a-menu-item>
            <a-menu-item key="5" @click="onLockScreen">
                <LockOutlined />
                <span>{{ $t('tools.userMenu.lockScreen') }}</span>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item key="3"  @click="handleLogout">
                <LogoutOutlined />
                <span>{{ $t('tools.userMenu.logout') }}</span>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <span  class="action">
        <SelectLang :class="theme" class="action" />
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup name="UserMenu">
import NoticeIcon from '@/components/NoticeIcon/index.vue'
import { USER_INFO } from '@/store/mutation-types'
import { Modal } from 'ant-design-vue'
import {
  QuestionCircleOutlined,CheckOutlined,CloseOutlined,
  SettingOutlined,
  LogoutOutlined,
  LockOutlined,UserOutlined
} from '@ant-design/icons-vue'
import { useI18n } from 'vue-i18n'
import { systemConfig } from '@/store/reactiveState'
import SelectLang from '@/components/SelectLang'
import ls from '@/utils/Storage'
import { useRouter } from 'vue-router'
import { clearUserInfo ,baseURL} from '@/utils/util'
import { getCurrentInstance,ComponentInternalInstance, onMounted,ref,nextTick  } from 'vue'
import { isConnect,mqttstart } from '@/utils/mqttclient'

const configs= getCurrentInstance().appContext.config.globalProperties
const props = defineProps(['theme'])
const { t } = useI18n()
const router = useRouter()
const UserInfo = ls.get(USER_INFO)
const mqttConnect=ref<Boolean>(isConnect())
configs.$on('mqttconnect',(e)=>{
    mqttConnect.value=e
})
onMounted(()=>{
  if(mqttConnect.value==false&&UserInfo){
    mqttstart(UserInfo.userid,getCurrentInstance())
  }
})

const handleLogout = () => {
  Modal.confirm({
    title: t('tools.userMenu.tip'),
    content: t('tools.userMenu.checkLogout'),
    onOk: () => {
      //退出时，要关闭mqtt
      if(configs.$mqtt){
        configs.$mqtt.end()
        configs.$mqtt=null
      }
      clearUserInfo()
      router.push({ path: '/login' })
    }
  })
}
const showSystemSetting = () => {
  systemConfig.commit('SET_SETTING_DRAWER', true)
}

const onLockScreen = () => {
  systemConfig.commit('SET_LOCK_SCREEN', true)
}
</script>
<style lang="less">
.user-dropdown-menu-wrapper {
  .ant-dropdown-menu-item {
    width: 100% !important;
  }
}
</style>
